(function($, FUNCTIONS){
	const region = FUNCTIONS.va.region;
	const arrowPrev = '<button type="button" class="slick-prev"><svg><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// ＜商品TOP＞メインビジュアルスライダー
	const mainVisSlider = () => {
		$('.prod-idx-main-slide').slick({
			autoplay: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			loop: true,
			infinite: true,
			dots: true,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			centerMode: true,
			centerPadding: 0,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	};

	// ＜商品TOP＞ シーン別 スライダー
	const enjoySceneSlider = () => {
		$('.idx-enjoy-scene-slide').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			infinite: false,
			dots: false,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});
		if (FUNCTIONS.va.window.width >= 1024) {
			$('.idx-enjoy-scene .__head').css('height', $('.idx-enjoy-scene-slide img:first-child').height());
		}
	};

	// ＜商品TOP＞ pickup スライダー
	const pickupSlider = () => {
		$('.idx-pickup-slide').slick({
			autoplay: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			loop: true,
			infinite: true,
			dots: true,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	};

	// ＜カテゴリ＞ おすすめ商品スライダー
	const prodCatRecommendSlider = () => {
		$('.prod-cat-recommend-slide').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	};

	// ＜商品詳細＞ 商品ラインアップ／シリーズ商品
	const getJSONprodLineup = (_category, _brand, _seriesCode, _lineupCode, _prodID) => {
		let jsonPath = (region === 'jp') ?
			`/ajax/product/${_category}/${_brand}/${_seriesCode}/lineup.json?lineup=${_lineupCode}&exclude_code=${_prodID}`	:
			`/global/${region}/ajax/product/${_brand}/${_seriesCode}/lineup.json?lineup=${_lineupCode}&exclude_code=${_prodID}`; // globalはカテゴリなし
		return $.getJSON(jsonPath);
	};
	const getJSONprodSeries = (_category, _brand, _seriesCode) => {
		let jsonPath = (region === 'jp') ?
			`/ajax/product/${_category}/${_brand}/${_seriesCode}.json` :
			`/global/${region}/ajax/product/${_brand}/${_seriesCode}.json`;
		return $.getJSON(jsonPath);
	};
	const getJSONprodDetail = (_prodKey) => {
		let jsonPath = (region === 'jp') ?
			`/ajax/product/${_prodKey}.json` :
			`/global/${region}/ajax/product/${_prodKey}.json`;
		return $.getJSON(jsonPath);
	};

	const prodDetailSetLineupSeries = () => {
		let category = FUNCTIONS.va.pathname.split('/')[2];
		let brand = (region === 'jp') ? FUNCTIONS.va.pathname.split('/')[3] : FUNCTIONS.va.pathname.split('/')[4];
		let seriesCode = $('.rt_cf_p_series_code').attr('data-series_code');
		let lineupCode = $('.rt_cf_p_lineup_code').attr('data-lineup_code');
		let prodID = (region === 'jp') ? FUNCTIONS.va.pathname.split('/')[4].replace(/\.html/g, '') : FUNCTIONS.va.pathname.split('/')[5].replace(/\.html/g, '');

		// ラインナップ
		getJSONprodLineup(category, brand, seriesCode, lineupCode, prodID).then((data) => {
			if (data.rt_bn_product_list.length) {
				let lineupHTML = '';
				for (let i = 0; i < data.rt_bn_product_list.length; i++) {
					lineupHTML +=
						`<li><a href="${data.rt_bn_product_list[i].rt_cf_p_href.href}" class="mod-boxLink01">` +
						`<figure><img src="${data.rt_bn_product_list[i].rt_cf_p_image_1.src}" alt="${data.rt_bn_product_list[i].rt_cf_p_image_1.alt}">` +
						`<figcaption class="ta_center">${data.rt_bn_product_list[i].cf_p_product_name}<br>`+
						`${data.rt_bn_product_list[i].cf_p_amount_for_display}`;
					if (data.rt_bn_product_list[i].cf_p_container_for_display) { // 容器の登録があれば表示
						lineupHTML += `／${data.rt_bn_product_list[i].cf_p_container_for_display}`;
					}
					if (region === 'jp') {
						// 国内のみ価格表示
						lineupHTML += `<br>${data.rt_bn_product_list[i].cf_p_price_excluding_tax}（税込 ${data.rt_bn_product_list[i].cf_p_price_tax_included}）`;
					}
					lineupHTML += '</figcaption></figure></a></li>';
				}
				$('.js-lineup').append(lineupHTML);
				$('.js-lineup').slick({
					slidesToShow: 6,
					slidesToScroll: 1,
					infinite: false,
					arrows: true,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 4
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2
							}
						}
					]
				});
			} else {
				$('.js-lineup-wrap').remove();
			}
		});

		// シリーズ
		const setProdItem = async (_keyArr) => {
			let seriesHTMLArr = [];
			for (let i = 0; i < _keyArr.length; i++) {
				const data = await getJSONprodDetail(_keyArr[i]);
				if (data.rt_bn_product_list.length) {
					seriesHTMLArr.push(
						`<li><a href="${data.rt_bn_product_list[0].rt_cf_p_href.href}" class="mod-boxLink01">` +
						`<figure><img src="${data.rt_bn_product_list[0].rt_cf_p_image_1.src}" alt="${data.rt_bn_product_list[0].rt_cf_p_image_1.alt}">` +
						`<figcaption class="ta_center">${data.rt_bn_product_list[0].cf_p_product_name}</figcaption></figure></a></li>`);
				}
			}
			return seriesHTMLArr;
		};

		getJSONprodSeries(category, brand, seriesCode).then((data) => {
			let seriesData;
			switch (region) {
				case 'jp': seriesData = data.rt_bn_series[0].cf_ps_pickup_products_jp; break;
				case 'cn': seriesData = data.rt_bn_series[0].cf_ps_pickup_products_cn; break;
				case 'eu': seriesData = data.rt_bn_series[0].cf_ps_pickup_products_eu; break;
				case 'us': seriesData = data.rt_bn_series[0].cf_ps_pickup_products_us; break;
				default: seriesData = data.rt_bn_series[0].cf_ps_pickup_products_jp; break;
			}
			if (seriesData) {
				let keyArr = [];
				for (let i = 0; i < seriesData.length; i++) {
					if (seriesData[i].cf_p_status === 1) {
						keyArr.push(seriesData[i]._key);
					}
				}
				setProdItem(keyArr).then((seriesHTMLArr) => {
					for (let j = 0; j < seriesHTMLArr.length; j++) {
						$('.js-series').append(seriesHTMLArr[j]);
					}
					$('.js-series').slick({
						slidesToShow: 6,
						slidesToScroll: 1,
						infinite: false,
						arrows: true,
						prevArrow: arrowPrev,
						nextArrow: arrowNext,
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									slidesToShow: 4
								}
							},
							{
								breakpoint: 767,
								settings: {
									slidesToShow: 2
								}
							}
						]
					});
				});
			} else {
				$('.js-series-wrap').remove();
			}
		});
	};

	// ＜商品詳細＞栄養成分等 空要素削除
	const removeEmptyNutrition = () => {
		if (!$('.rt_cf_p_category_is_cosmetics_is_not').find('h3').find('span').length &&
			!$('.rt_cf_p_category_is_cosmetics_is_not').find('ul').find('li').length) {
			// <h3>～</h3>内には<span>タグが無い、かつ、<ul>～</ul>内には<li>タグが無い場合 枠ごと削除
			$('.rt_cf_p_category_is_cosmetics_is_not').remove();
		}
	};

	// ＜商品詳細＞ 商品画像スライダー
	const prodDetailMainSlider = () => {
		$('.prod-detail-main-slide').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			arrows: false,
			asNavFor: '.prod-detail-main-subSlide'
		});
		$('.prod-detail-main-subSlide').slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			asNavFor: '.prod-detail-main-slide',
			focusOnSelect: true
		});
	};

	// ＜商品検索（国内のみ）＞ ブランドリスト取得
	const getJSONBrandList = (_category) => {
		console.log(`/ajax/product/${_category}/brand.json`);
		return $.getJSON(`/ajax/product/${_category}/brand.json`);
	};
	const prodSearchSetBrand = () => {
		let thisCat = FUNCTIONS.va.pathname.split('/')[2];
		let brandListHTML = '';
		getJSONBrandList(thisCat).then((data) => {
			if (data.rt_bn_product_brand_list.length) {
				for (let i = 0; i < data.rt_bn_product_brand_list.length; i++) {
					brandListHTML += `<li><a href="/product/${thisCat}/list/?p_brand=${data.rt_bn_product_brand_list[i]._key}" class="__innerItem">` +
						`${data.rt_bn_product_brand_list[i].cf_pb_name_jp}</a></li>`;
				}
				$('.js-brandList').append(brandListHTML);

				// 検索項目のアコーディオン開閉
				let thisSearchArr = location.search.slice(1).split('&');
				for (let i = 0; i < thisSearchArr.length; i++) {
					if (thisSearchArr[i].indexOf('p_') === 0) {
						$('.prod-search-nav').find('a').each((idx, ele) => {
							if ($(ele).attr('href').indexOf(thisSearchArr[i]) !== -1) {
								$(ele).addClass('is-active');
								$(ele).parents('.js-toggleBlock').css('display', 'block');
								$(ele).parents('.js-toggleBlock').prev('.js-toggle').addClass('is-active');
							}
						});
					}
				}
			} else {
				$('.js-brandList-wrap').remove();
			}
		});
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	mainVisSlider();
	enjoySceneSlider();
	pickupSlider();
	prodCatRecommendSlider();

	if ($('.prod-detail').length) {
		prodDetailMainSlider();
		prodDetailSetLineupSeries();
		removeEmptyNutrition();
	}
	if ($('.prod-cat-search').length) {
		prodSearchSetBrand();
	}

})(window.jQuery, window.FUNCTIONS);
